import * as p from '@clack/prompts'

export async function promptConfirm(message: string): Promise<boolean> {
  const result = await p.confirm({
    message,
    initialValue: true
  })

  if (p.isCancel(result)) {
    throw new Error('Generation cancelled.')
  }

  return Boolean(result)
}
